import { render } from "./LevelTestPage.vue?vue&type=template&id=10ef86b1&scoped=true"
import script from "./LevelTestPage.vue?vue&type=script&lang=js"
export * from "./LevelTestPage.vue?vue&type=script&lang=js"

import "./LevelTestPage.vue?vue&type=style&index=0&id=10ef86b1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ef86b1"]])

export default __exports__